import { render, staticRenderFns } from "./DefinitionWizard.vue?vue&type=template&id=3f5a9a1e&scoped=true"
import script from "./DefinitionWizard.vue?vue&type=script&lang=js"
export * from "./DefinitionWizard.vue?vue&type=script&lang=js"
import style0 from "./DefinitionWizard.vue?vue&type=style&index=0&id=3f5a9a1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a9a1e",
  null
  
)

export default component.exports